import FlowActions from 'bukku/redux/Flow/actions';
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import CompanyActions from 'bukku/redux/Company/actions';

const {
    readAllDigests,
} = FlowActions;

const {
    readCompany,
} = CompanyActions;

export const useAsyncSideEffects = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const fetchDataAfterNotified = notificationData => {
        console.log('notificationData xxxxxxx', notificationData);
        if (!notificationData)
            return;

        const {
            title, // 'SUCCESS', 'ERROR', 'WARNING', 'INFO', null
        } = notificationData;

        switch (title) {
            case 'Post to Invoice': {
            // fetch digests again if currently inside digests page
                const pattern = /^\/flow\/streams\/(\d+)\/digests$/;

                const isDigestsPage = pattern.test(location.pathname);
                const match = location.pathname.match(pattern);
                const streamId = match ? match[1] : null;
                const queryParams = queryString.parse(location.search, {arrayFormat: 'bracket'});

                if (isDigestsPage)
                    dispatch(readAllDigests(streamId, queryParams));
                break;
            }
            default:
                break;
        }
    };

    const updateCompanyProfileRedux = eventData => {
        dispatch(readCompany({company: eventData.data}));
    };

    return {
        fetchDataAfterNotified,
        updateCompanyProfileRedux,
    };
};
